import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatPanelComponent } from './chat-panel/chat-panel.component';
import {FormsModule} from '@angular/forms';
import { ChatMessageComponent } from './chat-message/chat-message.component';
import { ChatHotelSliderComponent } from './chat-hotel-slider/chat-hotel-slider.component';
import { ChatDynamicTableComponent } from './chat-dynamic-table/chat-dynamic-table.component';

@NgModule({
  declarations: [
    ChatPanelComponent,
    ChatMessageComponent,
    ChatHotelSliderComponent,
    ChatDynamicTableComponent,
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [
    ChatPanelComponent,
    ChatMessageComponent,
    ChatHotelSliderComponent,
    ChatDynamicTableComponent,
  ]
})
export class SurfChatAgentModule {}
